/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import { IBatteryStatus } from '@shared/interfaces';
const UPDATE_BATTERY_STATUS = 'UPDATE_BATTERY_STATUS';

export const updateBatteryStatus = createAction(
    UPDATE_BATTERY_STATUS,
    props<{ batteryStatus: IBatteryStatus }>()
);
